/**
 * Directive: textareaFieldWithLabel
 */
angular.module('acme.common.directive.textareaFieldWithLabel', [
  'acme.common.directive.inputFieldError',
  'acme.common.directive.fieldFocus'
])
.directive('textareaFieldWithLabel', [function() {

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/textareaFieldWithLabel/textareaFieldWithLabel.tpl.html',
    scope: {
      name: '@',
      label: '@',
      icon: '@',
      useFullWidth: '@', // Used in conjunction with maxlength to prevent constrained width
      model: '=',
      modelChanged: '&',
      notifyOnBlur: '@',
      disabled: '=',
      useCancel: '@',
      setFieldFocus: '@setfieldfocus',
      fieldFocusTimeout: '@',
      maxLength: '@maxlength',
      hideLabel: '@hidelabel',
      validTest: '=validtest',
      errorMessage: '=errormessage',
      errors: '=',
      fieldName: '@',
      rows: '@',
      required: '@'
    },

    link: function($scope, $element, $attrs) {
      var textarea = $element.children('textarea');

      textarea.bind('scroll', function () {
        $scope.textareaFieldWithLabel.scrolled = !!textarea.scrollTop();
        $scope.$apply();
      });
    },

    controller: ['$scope', function($scope) {

      $scope.textareaFieldWithLabel = {

        setFieldFocus: $scope.setFieldFocus,
        scrolled: false,
        placeholder: $scope.placeholderValue || '',
        groupTypeClass: ($scope.isPanelGroup) ? 'panel-form-group' : 'form-group',
        fieldFocusTimeout: ($scope.fieldFocusTimeout) ? $scope.fieldFocusTimeout : 0,

        label: $scope.label || ($scope.placeholderValue || ''),

        init: function() {


          watcher = $scope.$watch('errors', function() {
            if ($scope.errors && $scope.errors[$scope.fieldName]) {
              $scope.textareaFieldWithLabel.error = $scope.errors[$scope.fieldName].message;
            }else{
              $scope.textareaFieldWithLabel.error = false;
            }
          });

          $scope.$on('destroy', this.onDestroy);
        },

        onDestroy: function() {
          watcher();
        },

        checkValid: function() {
          var r = true;

          if ($scope.errorMessage) {
            r = (($scope.validTest !== undefined) ? $scope.validTest : true);
          } else {
            r = !this.error;
          }
          return r;
        },

        notifyOnChange: function() {
          return !($scope.notifyOnBlur && ($scope.notifyOnBlur === true || $scope.notifyOnBlur === 'true'));
        },

        onChanged: function() {
          if (this.notifyOnChange() && (typeof $scope.modelChanged === 'function')) {
            $scope.modelChanged();
          }
        },

        onBlur: function() {
          if (typeof $scope.modelChanged === 'function') {
            $scope.modelChanged();
          }
        }

      };

      $scope.textareaFieldWithLabel.init();

    }]

  };

}]);